import { useEffect, useState } from 'react'

/**
 * Subscribes to a CSS media query (`matchMedia`), re-rendering when it flips. No `matchMedia` call
 * existed anywhere in this codebase before the theme feature — this is the one place a media
 * FEATURE (as opposed to a fixed breakpoint, see lib/useBreakpoint-style logic in components) is
 * read: `system` theme resolution (`prefers-contrast`, `prefers-color-scheme`) in theme.tsx.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches)

  useEffect(() => {
    const mql = window.matchMedia(query)
    const onChange = (): void => setMatches(mql.matches)
    onChange()
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [query])

  return matches
}
